module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5b3e93a54812411820707a52775f408d.png";